const firebaseConfig = {
    apiKey: "AIzaSyCy0i6OLw_EJCiHkmupQK5QASU752f3ebU",
    authDomain: "tour-plan-98f51.firebaseapp.com",
    projectId: "tour-plan-98f51",
    storageBucket: "tour-plan-98f51.appspot.com",
    messagingSenderId: "205091514421",
    appId: "1:205091514421:web:0f3c21f7dc2e7fdee6297c"
  };

  export default firebaseConfig;